import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

import SyncPanel from './components/SyncPanel';

import './status.scss';

const Status = ({
  call, syncHistory, syncLogs, tick, syncError
}) => (
  <div>
    <div className="main">
      { syncHistory && ((syncHistory.syncId && (
        <SyncPanel
          call={ call }
          syncHistory={ syncHistory }
          syncLogs = { syncLogs }
          tick={ tick }
          syncError = { syncError }
        />
      )) || (
        <div style={ { textAlign: 'center' } }>
          <Header size="large">Status: Not Connected</Header>

          <p>Click the &quot;Set-up&quot; tab to connect QuickBooks to MHD.</p>
        </div>
      )) }
    </div>
  </div>
);

Status.defaultProps = {
  syncHistory: null,
  syncLogs: null,
};

Status.propTypes = {
  syncHistory: PropTypes.object,
  syncLogs: PropTypes.object,
  syncError: PropTypes.string,

  // functions
  call: PropTypes.func.isRequired,
  tick: PropTypes.func.isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/Status/index.js